export default function LinearCard(props) {
  const { className } = props;

  return <div className={`card ${className}`}>{props.children}</div>;
}
